export enum SettingsKey {
  'enableTodayAsDefaultValueForDateTime' = 'enableTodayAsDefaultValueForDateTime',
  'PricingAtOrderingServiceLevel' = 'PricingAtOrderingServiceLevel',
  'enableShipping' = 'enableShipping',
  'EnableSmartLabelPrinting' = 'EnableSmartLabelPrinting',
  'DisplaySampleAttachment' = 'DisplaySampleAttachment',
  // EOL menu related keys
  'EnableOSIS' = 'EnableOSIS',
  'newWaysOfCreatingOrdersEnabled' = 'newWaysOfCreatingOrdersEnabled',
  'DisableViewQuotation' = 'DisableViewQuotation',
  'EnableProject' = 'EnableProject',
  'EnableSampleTaker' = 'EnableSampleTaker',
  'disableLimitSets' = 'disableLimitSets',
  'EnableMyStatistics' = 'EnableMyStatistics',
  'enableFloorplans' = 'enableFloorplans',
  'enableSampleStatusTracking' = 'enableSampleStatusTracking',
  'useResults' = 'useResults',
  'disableInvoices' = 'disableInvoices',
  'enableDropOff' = 'enableDropOff',
  'enableAlerts' = 'enableAlerts',
  'EnableSampleQuantityDisplay' = 'EnableSampleQuantityDisplay',
  'enableContactPage' = 'enableContactPage',
  'enableProductManagement' = 'enableProductManagement',
  'EnableLabContactPage' = 'EnableLabContactPage',
  'EIMASLogonURL' = 'EIMASLogonURL',
  'EIMASClientApplicationID' = 'EIMASClientApplicationID',
  'EnableAdvancedSupportPage' = 'EnableAdvancedSupportPage',
  'ExpressOrderingUrl' = 'ExpressOrderingUrl',
  'EnableExpressOrdering' = 'EnableExpressOrdering',
  'ConfigureSortPatternUri' = 'ConfigureSortPatternUri',
  'ProductManagementEIMASLogonURL' = 'ProductManagementEIMASLogonURL',
  'ManageFavouriteOrders' = 'ManageFavouriteOrders',
  'usePartialOrderEntry' = 'usePartialOrderEntry',
  'useOfferFileExport' = 'useOfferFileExport',
  'DisableParameterSortings' = 'DisableParameterSortings',
  'EnableLocalApplicationIntegration' = 'EnableLocalApplicationIntegration',
  'enableMultipleAssessments' = 'enableMultipleAssessments',
  'enableOSOIntegration' = 'enableOSOIntegration',
  'useResultsV2' = 'useResultsV2',
  'useResultsConfiguration' = 'useResultsConfiguration',
  'enableSelfreport' = 'enableSelfreport',
  'enableDashboard' = 'enableDashboard',
  'enableOrderResultsView' = 'enableOrderResultsView',
  'useDocumentSharing' = 'useDocumentSharing',
  'resultViewAccounts' = 'resultViewAccounts',
  'enableGuidedOrder' = 'enableGuidedOrder',
  'ConfigureMonograph' = 'ConfigureMonograph',
  'defaultRegulations' = 'defaultRegulations',
  'DefaultOrderingService' = 'DefaultOrderingService',
  'FrequentlyUsedDenUnits' = 'FrequentlyUsedDenUnits',
  'FrequentlyUsedNumUnits' = 'FrequentlyUsedNumUnits',
  'MaxSelectionOfAnalyses' = 'MaxSelectionOfAnalyses',
  'EnableSchedulingRecurrentOrder' = 'EnableSchedulingRecurrentOrder',
  'ELIMSTransitionedLabsiteAccounts' = 'ELIMSTransitionedLabsiteAccounts'
}
